/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_EventInputs */

const th_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรายการแข่งขันนี้`)
};

const en_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That event does not exist.`)
};

const ja_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この大会は存在しません。`)
};

const zh_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该赛事不存在。`)
};

const es_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese evento no existe.`)
};

const pt_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse evento não existe.`)
};

const id_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara itu tidak ada.`)
};

const fr_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet événement n’existe pas.`)
};

const tl_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang event na iyon.`)
};

const vi_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có sự kiện đó.`)
};

const ko_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 이벤트는 없습니다.`)
};

const de_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Event gibt es nicht.`)
};

const ru_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого события нет.`)
};

const tr_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir etkinlik yok.`)
};

const it_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'evento non esiste.`)
};

const pl_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takie wydarzenie nie istnieje.`)
};

const uk_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такої події немає.`)
};

const hi_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह आयोजन मौजूद नहीं है।`)
};

const ar_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك الفعالية غير موجودة.`)
};

const ms_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara itu tidak wujud.`)
};

const bn_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই আয়োজন নেই।`)
};

const zh_tw2_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該賽事不存在。`)
};

const zh_hk2_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該賽事不存在。`)
};

const ur_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ ایونٹ موجود نہیں۔`)
};

const fa_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین رویدادی وجود ندارد.`)
};

const sw_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio hilo halipo.`)
};

const nl_not_found_event = /** @type {(inputs: Not_Found_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat evenement bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That event does not exist." |
*
* @param {Not_Found_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_found_event = /** @type {((inputs?: Not_Found_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_not_found_event(inputs)
	if (locale === "ja") return ja_not_found_event(inputs)
	if (locale === "zh") return zh_not_found_event(inputs)
	if (locale === "es") return es_not_found_event(inputs)
	if (locale === "pt") return pt_not_found_event(inputs)
	if (locale === "id") return id_not_found_event(inputs)
	if (locale === "fr") return fr_not_found_event(inputs)
	if (locale === "tl") return tl_not_found_event(inputs)
	if (locale === "vi") return vi_not_found_event(inputs)
	if (locale === "ko") return ko_not_found_event(inputs)
	if (locale === "de") return de_not_found_event(inputs)
	if (locale === "ru") return ru_not_found_event(inputs)
	if (locale === "tr") return tr_not_found_event(inputs)
	if (locale === "it") return it_not_found_event(inputs)
	if (locale === "pl") return pl_not_found_event(inputs)
	if (locale === "uk") return uk_not_found_event(inputs)
	if (locale === "hi") return hi_not_found_event(inputs)
	if (locale === "ar") return ar_not_found_event(inputs)
	if (locale === "ms") return ms_not_found_event(inputs)
	if (locale === "bn") return bn_not_found_event(inputs)
	if (locale === "zh-TW") return zh_tw2_not_found_event(inputs)
	if (locale === "zh-HK") return zh_hk2_not_found_event(inputs)
	if (locale === "ur") return ur_not_found_event(inputs)
	if (locale === "fa") return fa_not_found_event(inputs)
	if (locale === "sw") return sw_not_found_event(inputs)
	if (locale === "nl") return nl_not_found_event(inputs)
	return en_not_found_event(inputs)
});